module.exports = "pegasus/assets/themelp1/large/40.png";